import { StreamChat } from 'stream-chat';
import messageStore from 'store/message.js'
import recieverStore from 'store/reciever';
import sessionStore from 'store/session';
import { get } from 'svelte/store';
import { STREAM_CHAT_API_KEY, avatarRight } from "../constant"

export class StreamChatProvider {

    constructor() {
        if (StreamChatProvider.instance) {
            return StreamChatProvider.instance;
        }
        this.messages = [];
        const client = StreamChat.getInstance(STREAM_CHAT_API_KEY, { enableWSFallBack: true });
        this.client = client;
        const self = this
        this.connectUser().then( res => {
            const { me } = res
            self.user = me
            self.channel = client.channel('messaging', 
                'admins',
                // {members: [me.id]}, 
                {
                    name: 'General admin channel',
                }
            );
            self.channel.watch();
            self.listenForNewMessages();
        });
        StreamChatProvider.instance = this;
    }

    static getInstance() {
        if (StreamChatProvider.instance) return StreamChatProvider.instance
        return new StreamChatProvider()
    }

    async connectUser() {
        const { user, avatar } = get(recieverStore)
        const { first_name, last_name, id } = user
        const userId = `${id}`

        if (!avatar) recieverStore.setAvatar(avatarRight);
    
        return await this.client
        // .connectUser(
        .setGuestUser(
            {
                id: userId,
                name: `${first_name} ${last_name}`,
                image: avatar || avatarRight,
            },
            // "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiMSJ9.Sdqm2DOAMw5YKmkO4NVPCSCWW5-G2pzDCODxdSjFEdU",
            this.client.devToken(userId),
        );
    }

    async send(message, option = {}) {
        await StreamChatProvider.getInstance().channel.sendMessage({message, ...option});
    }

    async sendImage(e) {
        const files = e.target.files;
        return await StreamChatProvider.getInstance().channel.sendImage(files[0]);
    }

    getMessages() {
        return get(messageStore).messages;
    }

    listenForNewMessages() {
        this.channel.on('message.new', event => {
            const { message } = event;
            console.log(message)
            const { user } = message;
            const _userids = user.id.split("-")
            const userid = _userids[_userids.length - 1]
            if ( `${get(recieverStore).user.id}` !== userid ) {
                messageStore.push(event.message)
            }
            const chatDiv = document.getElementById("chat-container");
            chatDiv.scrollTop = chatDiv.scrollHeight;
        });
    }

    async getChannels(cid = null) {
        if ( !this.channel ) {
            const self = this
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve(self.getChannels())
                }, 2000);
            })
        }
        const filter = { type: 'messaging' };
        if (cid) {filter.id = { $in: [cid] }}
        else {
            filter.agent_id = { $in: get(sessionStore).receivers.map( r => `${r.id}`) }
        }
        
        const sort = [{ last_message_at: -1 }];

        return await this.client.queryChannels(filter, sort, {
            watch: true, // this is the default
            // state: true,
        });
    }

    async joinChannel({cid, userId}) {
        
        const channels = await this.getChannels(cid)
        if ( channels.length === 0) {
            throw Error("No channel found")
        }
        const channel = channels[0]
        console.log(channel)
        messageStore.set([
            ...channel.state.latestMessages,
            ...this.getMessages()
        ]);

        StreamChatProvider.getInstance().channel = channel;
        StreamChatProvider.getInstance().listenForNewMessages();

        return await channel.addMembers([userId]);
    }

    getUser() {
        return this.user;
    }
}
